import { DateTime } from 'luxon';
export var uptPaycodes = ['US FC Unpaid Time', 'US Unpaid Time'];
export var useDaysWithUpt = function (_a) {
    var timeSegmentDailyAggregation = _a.timeSegmentDailyAggregation;
    return ((timeSegmentDailyAggregation === null || timeSegmentDailyAggregation === void 0 ? void 0 : timeSegmentDailyAggregation.filter(function (_a) {
        var timeSegmentTypeId = _a.timeSegmentTypeId;
        return uptPaycodes.includes(timeSegmentTypeId);
    }).map(function (_a) {
        var date = _a.date;
        return DateTime.fromFormat(date, 'M/dd/yyyy');
    })) || []);
};
